import {
  CreateAnnouncementDto,
  CreatePrefilledFlixcheckUrlDto,
  IAnnouncement,
  IFlixcheckCheck,
} from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class FlixcheckApi {
  static async createPrefilledPolicyUrl(
    data: CreatePrefilledFlixcheckUrlDto,
  ): Promise<AxiosResponse<{ resource: { redirectUrl: string } }>> {
    return AdmiralApi.apiCall<{ resource: { redirectUrl: string } }>({
      method: 'POST',
      url: `${BASE_URL}/integrations/flixcheck/prefill-policy`,
      data,
    });
  }

  static async createPrefilledDamageUrl(
    data: CreatePrefilledFlixcheckUrlDto,
  ): Promise<AxiosResponse<{ resource: { redirectUrl: string } }>> {
    return AdmiralApi.apiCall<{ resource: { redirectUrl: string } }>({
      method: 'POST',
      url: `${BASE_URL}/integrations/flixcheck/prefill-damage`,
      data,
    });
  }

  static async connectToFlixcheck(userId: string, apiKey: string): Promise<AxiosResponse<string>> {
    return AdmiralApi.apiCall<string>({
      method: 'POST',
      url: `${BASE_URL}/integrations/flixcheck/connect`,
      data: { userId, apiKey },
    });
  }

  static async disconnect(): Promise<AxiosResponse<string>> {
    return AdmiralApi.apiCall<string>({
      method: 'POST',
      url: `${BASE_URL}/integrations/flixcheck/disconnect`,
    });
  }

  static async isConnected(): Promise<
    AxiosResponse<{ isConnected: boolean; userId?: string; apiKey?: string }>
  > {
    return AdmiralApi.apiCall<{ isConnected: boolean; userId?: string; apiKey?: string }>({
      method: 'POST',
      url: `${BASE_URL}/integrations/flixcheck/is-connected`,
    });
  }

  static async getPolicyChecks(policyId: string): Promise<AxiosResponse<IFlixcheckCheck[]>> {
    return AdmiralApi.apiCall<IFlixcheckCheck[]>({
      method: 'POST',
      url: `${BASE_URL}/integrations/flixcheck/policy/${policyId}/checks`,
    });
  }

  static async getDamageChecks(damageId: string): Promise<AxiosResponse<IFlixcheckCheck[]>> {
    return AdmiralApi.apiCall<IFlixcheckCheck[]>({
      method: 'POST',
      url: `${BASE_URL}/integrations/flixcheck/damage/${damageId}/checks`,
    });
  }

  static async downloadDocuments(checkId: string): Promise<AxiosResponse<Buffer>> {
    return AdmiralApi.apiCall<Buffer>({
      method: 'POST',
      url: `${BASE_URL}/integrations/flixcheck/download-documents/${checkId}`,
    });
  }
}
